export default __webpack_public_path__ + "static/media/3.4f0c85e0.png";